import styled, { css } from 'styled-components'

import { ReactComponent as ChevronVertical } from '@sketch/icons/chevron-vertical-16'

import { Checkbox, Dropdown, Navbar, SelectPopover } from '@sketch/components'
import { breakpoint } from '@sketch/global-styles'

export const ToggleWrapper = styled.div(
  ({ theme: { colors, fontSizes, radii } }) => css`
    width: 88px;
    height: 38px;
    padding: 10px; /* stylelint-disable-line scales/space */
    margin: 1px; /* stylelint-disable-line scales/space */

    display: flex;
    justify-content: space-between;
    align-items: center;

    color: ${colors.foreground.secondary.C};
    font-size: ${fontSizes.D};
    cursor: pointer;

    :hover,
    :focus {
      border-top-right-radius: ${radii.medium};
      border-bottom-right-radius: ${radii.medium};
      background-color: ${colors.state.hover};
      transition: background-color 0.3s ease-out;

      & svg {
        transition: color 0.3s ease-out;
        color: ${colors.foreground.secondary.A};
      }
    }

    ${breakpoint('sm')`
      height: 30px;
    `}
  `
)

export const IconWrapper = styled.div(
  ({ theme: { colors } }) => css`
    display: flex;
    color: ${colors.foreground.secondary.D};
    margin: 8px 0;
  `
)

export const StyledChevron = styled(ChevronVertical)`
  width: 12px;
  height: 12px;
`

export const StyledSelectPopover = styled(SelectPopover)`
  width: 270px;
`

export const StyledCheckbox = styled(Checkbox)`
  cursor: pointer;
`

export const StyledDropdownItem = styled(Dropdown.Item)`
  padding: 8px 12px 8px 12px;
`

export const StyledDropdownResetItem = styled(Dropdown.Item)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px 8px 12px;
`

export const Filter = styled(Navbar.Filter)`
  background-color: ${({ theme }) => theme.colors.background.secondary.B};

  input[type='search'] {
    /* Padding right includes the clear button and the options button */
    padding-right: 120px; /* stylelint-disable-line scales/space */
  }
`
